import { IOfferSpendByOfferViewLang } from '../../../types/lang'
import { EOfferSpendByOfferView } from '../../../types'

export const offerSpendByOfferViewLang: IOfferSpendByOfferViewLang = {
	offer_spend_by_offer_view: {
		[EOfferSpendByOfferView.Day]: 'день',
		[EOfferSpendByOfferView.Month]: 'месяц'
	}
}